import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { GatewayApi } from "./api";

const GatewayInfoItem = ({ label, value }) => (
  <li>
    <span style={{ fontWeight: "bold", marginRight: "5px" }}>{label}:</span>
    {value}
  </li>
);

const GatewayInfoList = ({ gatewayInfo }) => (
  <ul style={{ listStyleType: "none", padding: "3px" }}>
    <GatewayInfoItem label="Gateway device" value={gatewayInfo.gatewayType} />
    <GatewayInfoItem
      label="MAC Address"
      value={gatewayInfo.tosiboxInfo.macAddress}
    />
    <GatewayInfoItem
      label="Online status"
      value={gatewayInfo.tosiboxInfo.onlineStatus}
    />
    {gatewayInfo.gatewayType === "tosibox" && (
      <GatewayInfoItem
        label="Last known online"
        value={gatewayInfo.tosiboxInfo.lastOnline}
      />
    )}
    {gatewayInfo.machine != null && (
      <GatewayInfoItem label="Machine" value={gatewayInfo.machine} />
    )}
  </ul>
);

const GatewayInfo = ({ gateways }) => {
  const renderGatewayInfo = (gatewayInfo) => {
    if (gatewayInfo.gatewayType == "None found") {
      return <GatewayInfoItem label="Gateway device" value={"None found"} />;
    } else {
      return <GatewayInfoList gatewayInfo={gatewayInfo} />;
    }
  };
  return (
    <div>
      {gateways.map((gatewayInfo, index) => (
        <div key={gatewayInfo.id || index} style={{ padding: "10px" }}>
          {renderGatewayInfo(gatewayInfo)}
        </div>
      ))}
    </div>
  );
};

export default GatewayInfo;
